import { render, staticRenderFns } from "./AnchorHandler.vue?vue&type=template&id=3cddf427&scoped=true&"
import script from "./AnchorHandler.vue?vue&type=script&lang=js&"
export * from "./AnchorHandler.vue?vue&type=script&lang=js&"
import style0 from "./AnchorHandler.vue?vue&type=style&index=0&id=3cddf427&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cddf427",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\other\\DaMou-Frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3cddf427')) {
      api.createRecord('3cddf427', component.options)
    } else {
      api.reload('3cddf427', component.options)
    }
    module.hot.accept("./AnchorHandler.vue?vue&type=template&id=3cddf427&scoped=true&", function () {
      api.rerender('3cddf427', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/運勢書2024/AnchorHandler.vue"
export default component.exports